import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { FeedbackFormModel } from "../models/FeedbackFormModel";

export class AppPersistenceService extends BasicPersistenceService<FuelPricesUserFeedbackAppDefinition> {
	public getFormModelFromStore(): FeedbackFormModel {
		const applicationModel = this.getApplicationModel();
		return applicationModel.FormModel;
	}

	public setFormModelToStore(formModel: FeedbackFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.FormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}

}
